// Angular
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
// Material
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'kt-patient-vitals-view-dialog',
  templateUrl: './patient-vitals-view.dialog.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class PatientVitalsViewDialogComponent implements OnInit {
  // Public properties
  patientVitals: any;

  /**
   * Component constructor
   *
   * @param data: any
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit() {
    this.patientVitals = JSON.parse(this.data.vitals);
  }
}
